import type { FunctionComponent, SVGProps } from 'react';

export type PersonCircleIconProps = SVGProps<SVGSVGElement> & {
    readonly className?: string;
    readonly fill?: string;
    readonly height?: number | string;
    readonly width?: number | string;
};

export const PersonCircleIcon: FunctionComponent<PersonCircleIconProps> = ({
    className = '',
    height = 14,
    width = 15,
    ...props
}) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            className={className}
            fill="none"
            height={height}
            viewBox="0 0 15 14"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.6666 7C13.6666 10.3137 10.9803 13 7.66663 13C4.35292 13 1.66663 10.3137 1.66663 7C1.66663 3.68629 4.35292 1 7.66663 1C10.9803 1 13.6666 3.68629 13.6666 7ZM2.86663 7C2.86663 9.65097 5.01566 11.8 7.66663 11.8C10.3176 11.8 12.4666 9.65097 12.4666 7C12.4666 4.34903 10.3176 2.2 7.66663 2.2C5.01566 2.2 2.86663 4.34903 2.86663 7Z"
                fill="currentColor"
            />
            <path
                d="M13.6666 7C13.6666 10.3137 10.9803 13 7.66663 13C4.35292 13 1.66663 10.3137 1.66663 7C1.66663 3.68629 4.35292 1 7.66663 1C10.9803 1 13.6666 3.68629 13.6666 7ZM2.86663 7C2.86663 9.65097 5.01566 11.8 7.66663 11.8C10.3176 11.8 12.4666 9.65097 12.4666 7C12.4666 4.34903 10.3176 2.2 7.66663 2.2C5.01566 2.2 2.86663 4.34903 2.86663 7Z"
                fill="currentColor"
            />
            <g clipPath="url(#clip0_3328_4303)">
                <path
                    d="M5.54163 9.125V8.625C5.54163 8.07272 5.98934 7.625 6.54163 7.625H8.79163C9.34391 7.625 9.79163 8.07272 9.79163 8.625V9.125M8.91663 5.875C8.91663 6.56536 8.35698 7.125 7.66663 7.125C6.97627 7.125 6.41663 6.56536 6.41663 5.875C6.41663 5.18464 6.97627 4.625 7.66663 4.625C8.35698 4.625 8.91663 5.18464 8.91663 5.875Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3328_4303">
                    <rect fill="white" height="6" transform="translate(4.66663 4)" width="6" />
                </clipPath>
            </defs>
        </svg>
    );
};
